<template>
  <div class="form-holder">
    <slot name="form" :getNote="getNote.notes" :on="setNote"></slot>
    <slot name="actions" :note="getNote"></slot>
  </div>
</template>
<script>

export default {
	model: {
		prop: 'getNote',
		event: 'changeNote'
	},
	props: {
		getNote: {
			type: Object,
			default: () => {
				return {
					create_at: new Date().toISOString().substr(0, 10),
					created_by: "",
					notes: "",
				};
			},
		},
	},
	data() {
		return {
			notes: { value: "yes" },
		};
	},
	methods: {
		setNote(note) {
			this.getNote.notes = note;
		}
	},
	watch: {
		getNote: {
			deep: true,
			handler: function(val) {
				this.$emit('changeNote', val);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
//@import "form-notes.component";
//@import '@/assets/style/main.scss';
@import "FormNotes";
</style>
